import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import { ENABLE_AUTO_RENEW, UPDATE_CC_DETAILS } from './types';
import { enableAutoRenew, updateCCDetails } from '../../api';
import { MACCreditCardDetails } from 'modules/mac/duck/api/storage';

export const postUpdateCCDetails = (id: number) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const creditCardData = MACCreditCardDetails().load();

  const updateCCDetailsData = updateCCDetails(id, creditCardData, state);
  dispatch(thunkProgress(UPDATE_CC_DETAILS, updateCCDetailsData, { id }));
};

export const postEnableAutoRenew = (id: number) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const creditCardData = MACCreditCardDetails().load();

  const enableAutoRenewData = enableAutoRenew(id, creditCardData, state);
  dispatch(thunkProgress(ENABLE_AUTO_RENEW, enableAutoRenewData, { id }));
};
